import {loginClickHandler, auth} from "../googleAuth.js"
import {onAuthStateChanged} from "firebase/auth";
import {handleGoToHomeClickACB} from "../utilities.js"
import {enterQuizClickACB} from "../utilities.js"


export function ProfileView(props) {
    let quizIdCounter = 1; 
    return (
        <div className="card universal-margin universal-padding">
            <button type="button" className="btn btn-light floating-btn" onClick={enterQuizClickACB}>Start Quiz</button>
            {props.id ? (
                <div>
                        <h1 className="harry-font">Quiz History</h1>
                        {props.history ? (
                            <div>
                            <p>Hello, magic student. Here you can find the results of your magic academic journey.</p>


                            <table className="my-5">
                                <tr>
                                    <th className="w-25 harry-font">Attempt</th>
                                    <th className="w-25 harry-font">Date Taken</th>
                                    <th className="w-25 harry-font">Score</th>
                                </tr>
                                {props.history.map((historyitem) => quizHistoryCB(historyitem, quizIdCounter++))}
                                </table>
                            
                                
                            </div>
                        ): (<p>You haven't taken any quizzes.</p>)}

                </div>
            ) : (
                <div>
                    <h1 className="harry-font">You are not logged in. </h1>
                    <p>Log in to save and view your quiz history.</p>
                    
                    <div className="row">
                        <button class="btn ml-3 mr-3"  onClick={loginClickACB} id="authButton">Log In</button>
                        
                        <p>or</p>
                        <button class="secondary_btn ml-3"  onClick={handleGoToHomeClickACB} id="authButton">Go to Home</button>
                    </div>
                    
                </div>
                
            )}
        </div>
    );

    function quizHistoryCB(historyitem, quizId){
        return <tr>
            <td className="w-25">No.{quizId}</td>
            <td className="w-25">{historyitem.quizDateTime.slice(0, 10)}</td>
            <td className="w-25">{historyitem.score}</td>
        </tr>
    };

    function loginClickACB(){
        loginClickHandler();
        onAuthStateChanged(auth, (user) => props.setLoginHandler(user?.uid));
    }


}
